/*
 * ヘッダーのメニュー("_header-menu"は既存テーマのコア機能のため編集不可)を
 * 対象に、design03の「英語ラベル+日本語サブラベルの2段ホバー切替」を追記する
 * 軽量エンハンスメント。
 *
 * 管理画面のナビゲーションで項目タイトルを
 *   "E-BIKES / 電動アシスト自転車"
 * のように " / " 区切りで登録すると、自動的に2段表示に分割される。
 * 区切りが無いタイトルはそのまま1段で表示される(フォールバック)。
 *
 * 項目名を作り替える処理本体(window.blckBluearthEnhanceHeaderNav)は、
 * sections/blck-bluearth-header-nav-enhance.liquid のインラインスクリプトに置いている。
 * このファイルは type=module(遅延実行)で、コアの <overflow-list> が幅を計測する前に
 * 実行される保証がなく、長いラベルのまま計測されて項目が畳まれるのを避けるため。
 * ここでは、後から追加される要素(メガメニューの列など)の作り替えと、
 * <overflow-list> の再計算だけを受け持つ。
 */
function blckBluearthEnhanceHeaderNav(root) {
  if (typeof window.blckBluearthEnhanceHeaderNav === 'function') {
    window.blckBluearthEnhanceHeaderNav(root);
  }
}

/*
 * メニュー項目が「さらに表示する」へ畳まれたまま戻らない問題の対策。
 *
 * コアの <overflow-list> は自分自身のサイズ変化でしか再計算しない。そのため
 *  - ウィンドウを縮めてドロワー表示になり、再び広げてメニューが戻ったとき
 *  - 上の2段ラベル化で項目幅が変わったとき
 * に、計測が古い(または途中の)幅のまま固まり、全項目が収まる幅でも畳まれて残る。
 * コアが用意している 'reflow' イベントを送って再計算させる(コアは変更しない)。
 */
function blckBluearthRequestNavReflow(header) {
  const list = header.querySelector('overflow-list');
  if (!list) return;
  list.dispatchEvent(new CustomEvent('reflow', { detail: {} }));
}

/*
 * <overflow-list> は自分の初期化(スタイル読み込み待ち)が終わってから 'reflow' を受け付ける。
 * 読み込みの遅い環境では、こちらの合図が先に届いて取りこぼされることがあるため、
 * 初期化が済んだ印(--overflow-count が設定される)を確認できるまで再送する。
 * 初期化後の再計算が済んだら、ヘッダーに data-blck-ready を付けて表示を解禁する
 * (それまでは liquid 側のCSSでメニューを隠している)。
 */
function blckBluearthSettleNav(header) {
  let tries = 0;
  const markReady = () => header.setAttribute('data-blck-ready', '');
  const tick = () => {
    const list = header.querySelector('overflow-list');
    if (!list) return markReady();
    blckBluearthRequestNavReflow(header);
    const initialized = list.style.getPropertyValue('--overflow-count') !== '';
    if (initialized || ++tries >= 40) return markReady();
    setTimeout(tick, 100);
  };
  tick();
}

function blckBluearthInitHeaderNavEnhance() {
  const header = document.getElementById('header-component');
  if (!header) return;

  let reflowTimer;
  const scheduleReflow = (delay) => {
    clearTimeout(reflowTimer);
    reflowTimer = setTimeout(() => blckBluearthRequestNavReflow(header), delay);
  };

  blckBluearthEnhanceHeaderNav(header);

  // Mega-menu columns are populated lazily by the theme's own header script,
  // so keep watching for new/changed nodes instead of running once.
  const observer = new MutationObserver(() => {
    const before = header.querySelectorAll('[data-blck-split]').length;
    blckBluearthEnhanceHeaderNav(header);
      // 新しく2段ラベル化した項目があるときだけ再計算する(項目幅が変わるため)
    if (header.querySelectorAll('[data-blck-split]').length !== before) scheduleReflow(100);
  });
  observer.observe(header, { childList: true, subtree: true });

  // ウィンドウ幅の変更が落ち着いたら再計算(縮小→拡大の後にメニューを元に戻す)
  window.addEventListener('resize', () => scheduleReflow(200));

  // 初回表示: <overflow-list> の初期化を待って再計算し、済んだら表示を解禁する。
  // そのあとフォント・ページの読み込みが終わった時点の幅でも計測し直す。
  blckBluearthSettleNav(header);
  if (document.fonts?.ready) document.fonts.ready.then(() => scheduleReflow(100));
  window.addEventListener('load', () => scheduleReflow(100), { once: true });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', blckBluearthInitHeaderNavEnhance);
} else {
  blckBluearthInitHeaderNavEnhance();
}
